export default "fragment productImageFieldsFragment on ProductImage{\ntitle\nimg{\n#require `productImageFragment`\n...productImageFragment\n}\nurl\n}\n"